var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){!_vm.loading ? _vm.clicked() : null}}},[(_vm.loading)?[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-1x fa-fw"})]:_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }